module.exports = __webpack_public_path__ + "img/LATIN10_24.7015f1b6.jpg";